<mat-spinner
  class="spinner-middle"
  *ngIf="!init"
  color="primary"
  diameter="24"
></mat-spinner>

<mat-dialog-content class="action-dialog">
  <div *ngIf="init">
    <h2>Opmerkingen project #{{ projectId }}</h2>
    <ng-container *ngIf="subProject.type === 'BaseProject'">
      <div
        *ngFor="
          let product of project.products;
          let index = index;
          trackBy: trackById
        "
      >
        <textarea-input
          [title]="
            (product.type | productType: product.otherProductName) +
            ' #' +
            (index + 1)
          "
          [placeholder]="'Vul hier uw opmerkingen in'"
          [initContent]="product.productPlacement.installerInfo"
          (answer)="productInstallerInfoChanged($event, index)"
        ></textarea-input>
      </div>
    </ng-container>
    <ng-container *ngIf="subProject.type !== 'BaseProject'">
      <textarea-input
        [placeholder]="'Vul hier uw opmerkingen in'"
        [initContent]="subProject.withPlacementNotes"
        (answer)="withPlacementNotesChanged($event)"
      ></textarea-input>
    </ng-container>
  </div>
</mat-dialog-content>
<mat-dialog-actions class="float-right">
  <button
    type="button"
    (click)="closeDialog()"
    [disabled]="sending"
    class="btn btn-main btn-back"
  >
    Annuleer
  </button>
  <button
    type="button"
    (click)="save()"
    mat-button
    class="button"
    id="btnSend"
    [disabled]="sending"
  >
    Opslaan
  </button>
</mat-dialog-actions>
